import React, { useState } from 'react';
import { getMerchantStats } from '@/services/expenseService';
import { formatCurrency, formatDate } from '@/utils/formatters';
import LoadingSpinner from '@/components/shared/LoadingSpinner';

export default function MerchantAnalysis() {
  const [search, setSearch]   = useState('');
  const [stats, setStats]     = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  async function handleSearch() {
    const term = search.trim();
    if (!term) return;
    setLoading(true);
    setError('');
    setStats(null);
    try {
      const result = await getMerchantStats(term);
      if (result.count === 0) {
        setError(`No transactions found for "${term}"`);
      } else {
        setStats(result);
      }
    } catch (e) {
      setError('Failed to fetch merchant data');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="space-y-4">
      <div className="card">
        <h3 className="text-xs font-bold text-gray-600 mb-3">🏪 Merchant Analysis</h3>
        <div className="flex gap-2">
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSearch()}
            placeholder="Type exact vendor name (e.g. Instamart)…"
            className="input-field flex-1"
            aria-label="Search merchant"
          />
          <button onClick={handleSearch} className="btn-primary px-4">Search</button>
        </div>
        {error && <p className="text-xs text-danger mt-2">{error}</p>}
      </div>

      {loading && <LoadingSpinner />}

      {stats && (
        <div className="card border-l-4 border-success">
          <p className="text-base font-bold text-gray-800">🛒 {stats.vendor}</p>
          <div className="flex gap-4 mt-2">
            {[
              { label: 'Transactions', value: stats.count },
              { label: 'Total',        value: formatCurrency(stats.total) },
              { label: 'Average',      value: formatCurrency(stats.average) },
            ].map(({ label, value }) => (
              <div key={label}>
                <p className="text-xs text-gray-400">{label}</p>
                <p className="text-sm font-bold text-success">{value}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {stats?.transactions?.length > 0 && (
        <div className="card">
          <h3 className="text-xs font-bold text-gray-600 mb-2">Transaction History</h3>
          <div className="space-y-1">
            {stats.transactions.map(t => (
              <div key={t.id} className="flex justify-between text-xs py-1.5 border-b border-gray-50">
                <span className="text-gray-600">{formatDate(t.date)}</span>
                <span className="text-gray-400">{t.paymentMode}</span>
                <span className="font-semibold text-primary">{formatCurrency(t.amount)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
